<template>
  <section>
    <!--<header class="mui-bar mui-bar-nav">-->
      <!--<a class="mui-action-back mui-icon mui-icon-left-nav mui-pull-left"></a>-->
      <!--<h1 class="mui-title">发货管理</h1>-->
    <!--</header>-->
    <div class="mui-content pd-8">
      <div class="title-name">
        <span class="">发货管理</span>
      </div>
      <!--基础信息-->
      <div class="sampling-first" style="padding-bottom: 0px; padding-top: 15px;">
        <!--第二行内容-->
        <div class="form-group" style="width: 100%;padding-bottom: 0px;">
          <div class="input-label" style="flex: 4;">
            <label>当前供应商:</label>
          </div>
          <div class="form-input flex-1">
            <input type="text" v-model="ksmc" readonly>
          </div>
          <div class="flex-2" style="padding-top: 7px;padding-right:15px;text-align: right; box-sizing: border-box;">
            <label>
              <span class="mui-icon iconfont icon-icon-menus" id="filterbtn"  style="font-size: 30px;" @tap="query"></span>
            </label>
          </div>
        </div>
      </div>
      <div class="sampling-first" style="border-bottom: 0px;padding-top: 10px;">
        <!--第二行内容-->
        <div class="sampling-first-content">
        </div>
        <ul class="mui-table-view">
          <li class="mui-table-view-cell flex-content" style="display: block;margin-bottom: 10px;" v-for="(item,i) in infoLst">
            <div class="mui-slider-right mui-disabled" v-if="(item.ddqf!='2') && (zjmxflg(item)||tjfhflg(item))">
              <a class="mui-btn mui-btn-yellow" v-if="zjmxflg(item)" @tap="scanQRCodeBtn(item, $event)">指示明细</a>
              <a class="mui-btn mui-btn-red" v-if="tjfhflg(item)" @tap="tjfh(item, $event)">提交发货</a>
            </div>
            <div class="mui-slider-right mui-disabled" v-if="(item.ddqf=='2') && tjfhflg_bz(item)">
              <a class="mui-btn mui-btn-yellow" v-if="scancheckflg(item)" @tap="scanQRCodeComfirm(item, $event)">扫码装车</a>
              <a class="mui-btn mui-btn-red" v-if="!scancheckflg(item)" @tap="tjfh(item, $event)">提交发货</a>
            </div>
            <div class="mui-slider-handle">
              <div class="mui-table-cell" @tap="detail(item.shipmentno)">
                <!--第一个-->
                <div class="">
                  <div class="flex-box" >
                    <!-- <div class="flex-container">
                      <div class="flex-content-container flex-1">
                        <div class="flex-content-label" style="min-width: 76px;padding-right: 0px;">No：</div>
                        <div class="flex-content-span flex-1">{{i+1}}</div>
                      </div>
                      <div class="flex-content-container flex-1">
                        <div class="flex-content-label" style="min-width: 30px;"></div>
                        <div class="flex-content-span flex-1"></div>
                      </div>
                    </div> -->
                    <div class="flex-container">
                      <div class="flex-content-container flex-4">
                        <div class="flex-content-label" style="min-width: 76px;padding-right: 0px;">出库单号：</div>
                        <div class="flex-content-span">{{item.shipmentno}}</div>
                      </div>
                      <div class="flex-content-container flex-3">
                        <div class="flex-content-label" style="min-width: 19px;padding-right: 0px;"></div>
                        <div class="flex-content-span flex-1" style="padding-right: 15px;text-align: right;">No：{{i+1}}</div>
                      </div>
                    </div>
                    <!--<div class="flex-container">-->
                      <!--<div class="flex-content-container flex-1">-->
                        <!--<div class="flex-content-label" style="min-width: 76px;">指示日期：</div>-->
                        <!--<div class="flex-content-span">{{item.schedate}}</div>-->
                      <!--</div>-->
                      <!--<div class="flex-content-container flex-1">-->
                        <!--&lt;!&ndash;<div class="flex-content-label" style="min-width: 30px;">数量：</div>&ndash;&gt;-->
                        <!--&lt;!&ndash;<div class="flex-content-span flex-1">{{item.amount}}/{{item.sl}}{{item.dw}}</div>&ndash;&gt;-->
                      <!--</div>-->
                    <!--</div>-->
                    <div class="flex-container">
                      <div class="flex-content-container flex-4">
                        <div class="flex-content-label" style="min-width: 76px;padding-right: 0px;">坯布品号：</div>
                        <div class="flex-content-span flex-1" style="white-space: nowrap;">{{item.clothcode}}</div>
                      </div>
                      <div class="flex-content-container flex-3">
                        <div class="flex-content-label" style="min-width: 19px;"></div>
                        <div class="flex-content-span flex-strong" style="display: block;padding-right: 15px;">
                          <!--{{item.zszt}}-->
                          <div style="text-align: right;min-width: 60px;">{{item.zszt}}</div>
                          <div style="flex: 1;"></div>
                        </div>
                      </div>
                    </div>
                    <div class="flex-container">
                      <div class="flex-content-container flex-1">
                        <div class="flex-content-label" style="min-width: 76px;padding-right: 0px;">订单号：</div>
                        <div class="flex-content-span flex-1">{{item.ddh}}</div>
                      </div>
                      <div class="flex-content-container flex-1">
                        <div class="flex-content-label" style="min-width: 30px;"></div>
                        <div class="flex-content-span flex-1"></div>
                      </div>
                    </div>
                    <div class="flex-container">
                      <div class="flex-content-container flex-1">
                        <div class="flex-content-label" style="min-width: 76px;padding-right: 0px;">指示日期：</div>
                        <div class="flex-content-span">{{item.schedate}}</div>
                      </div>
                      <div class="flex-content-container flex-1">
                        <div class="flex-content-label" style="min-width: 30px;"></div>
                        <div class="flex-content-span flex-1"></div>
                      </div>
                    </div>
                    <div class="flex-container">
                      <div class="flex-content-container flex-1">
                        <div class="flex-content-label" style="min-width: 76px;padding-right: 0px;">数量：</div>
                        <div class="flex-content-span" style="white-space: nowrap;">{{item.zssl}}/{{item.amount}}{{item.dw}}（{{item.zsj}}卷{{item.zsp}}匹）</div>
                      </div>
                      <div class="flex-content-container flex-1">
                        <div class="flex-content-label" style="min-width: 30px;"></div>
                        <div class="flex-content-span flex-1"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  name: "delivery",
  data() {
    return {
      ksbh: "",
      ksmc: "",
      infoLst: [],
      deinfo: {},
      scan_count:0
    }
  },
  created() {
    var v = this;
    v.getKsbh();
    v.deinfo = {};
    // 获取默认查询内容
    v.getDefaultSearchInfo();
    v.eventBus.$on('deinfo', function(data) {
      if (data) {
        v.deinfo = data;
      }
    }.bind(this));

    v.nyy.wxInit();
  },
  activated() {
    var v = this;
    v.getDeliveryLst();
  },
  methods: {
    getDefaultSearchInfo(){ // 默认获取一周内的出库指示单号
      var v = this;
      var date = new Date(); //获取当前时间
      var now_date = v.getFormatDate(date);
      date.setDate(date.getDate() - 7); //设置天数 -7 天
      var from_date = v.getFormatDate(date);
      v.deinfo.schedate_fr = from_date;
      v.deinfo.schedate_to = now_date;
      v.deinfo.statusflg = "1"; // 0 已完成 1 未完成
      v.deinfo.scxtwpmc = ""; 
    },
    getFormatDate(date) {
      var seperator1 = "/";
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var strDate = date.getDate();
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      var currentdate = year + seperator1 + month + seperator1 + strDate;
      return currentdate;
    },
    // 编织模式下，已扫描卷的数量
    scancheckflg(item){
        if(item.ddqf != '2'){//机织、AB模式无需处理
          return false;
        }else{
          return (item.zsj != item.scannum);// 说明卷未全部扫码装车
        }
    },
    // 指示明细
    zjmxflg(item){
      if(item.ddqf=='2'){
        return false;
      }else{
        return (item.statusflg=='1')||((item.statusflg=='2')&&(item.approveflg=='2'||item.zjapproveflg=='2'||item.zkapproveflg=='2'));
      }
    },
    tjfhflg(item){
      return ((item.approveflg=='1')||(item.approveflg=='9'))&&((item.statusflg=='2'&&item.randomcheckflag=='1')||(item.statusflg=='3'&&item.randomcheckflag=='0'))&&(item.ddqf!='3'||(item.ddqf=='3' && (item.zjapproveflg=='1'||item.zjapproveflg=='9'||item.zjapproveflg=='') && (item.zkapproveflg=='1'||item.zkapproveflg=='9'||item.zkapproveflg=='')));
    },
    // 编织模式右边操作是否显示
    tjfhflg_bz(item){
      return ((item.approveflg=='1')||(item.approveflg=='9'))&&(item.statusflg=='2');
    },
    // 当前供应商
    getKsbh() {
      var v = this;
      v.nyy.doPost("/Quality/getKsbh", {},
        function(result) {
          if (result.status) {
            v.ksbh = result.data.ksbh;
            v.ksmc = result.data.ksmc;
          }else{
            mui.toast(result.message);
          }
        }
      );
    },
    getDeliveryLst() {
      var v = this;
      v.nyy.doPost("/Delivery/getDeliveryLst", {
          "ksbh": v.ksbh ? v.ksbh : "",
          "scxtwpmc": v.deinfo ? v.deinfo.scxtwpmc : "",
          "schedate_fr": v.deinfo ? v.deinfo.schedate_fr : "",
          "schedate_to": v.deinfo ? v.deinfo.schedate_to : "",
          "statusflg": v.deinfo ? v.deinfo.statusflg : "1" // 0 已完成 1 未完成
        },
        function(result) {
          if (result.status) {
            v.infoLst = result.data.infoLst;
          }else{
            mui.toast(result.message);
          }
        }
      );
    },
    detail(shipmentno) {
      var v = this;
      v.$router.push({ "name": "deliveryDetail", params: jsonPara({ "shipmentno": shipmentno }) });
    },
    query() {
      this.$router.push({ "name": "deliveryQuery", params: jsonPara(this.deinfo) });
    },
    // 提交发货
    tjfh(item, e) {
      var v = this;
      // 确认提示
      v.confirm_msg("您确认提交发货吗？",function(){
        var li =$(e.target).parents('li');
        if(li.length<=0)return;
        li = li[0];

        setTimeout(function() {
          mui.swipeoutClose(li);
        }, 0);

        v.nyy.doPost("/Delivery/update", {
            "ddh": item.ddh,
            "wph": item.wph,
            "shipmentno": item.shipmentno,
            "statusflg": "4" // 4、提交发货
          },
          function(result) {
            if (result.status) {
              mui.alert("当前指示单已提交发货","消息提示",function(){
                v.getDeliveryLst();
              });
            } else {
              mui.toast(result.message);
            }
          }
        );
      });
    },
    scanQRCodeBtn(item, e){
      var v = this;
      var li =$(e.target).parents('li');
      if(li.length<=0)return;
      li = li[0];

      setTimeout(function() {
        mui.swipeoutClose(li);
      }, 0);
      v.scanQRCode(item);
    },
    // 扫一扫
    scanQRCode(item) {
      var v = this;
      wx.scanQRCode({
        desc: 'scanQRCode desc',
        needResult: 1, // 默认为0，扫描结果由企业微信处理，1则直接返回扫描结果，
        scanType: ["qrCode", "barCode"], // 可以指定扫二维码还是一维码，默认二者都有
        success: function(res) {
          // 回调
          var result = res.resultStr; // 当needResult 为 1 时，扫码返回的结果
          if (!result > 1) {
            mui.toast('无效二维码')
          } else {
            // 扫TSD标签二维码，解析获取二维码的坯布信息，并保存到出库单下的明细中
            // TSD卷号截取，获取前8位 2020/06/28
            var rollstr = result.substr(0,8);
            v.addinfo(item, rollstr);
          }
        },
        error: function(res) {
          if (res.errMsg.indexOf('function_not_exist') > 0) {
            mui.toast('版本过低请升级')
          }
        }
      });
    },
    addinfo(item, tsdrollno) {
      var v = this;
      v.nyy.doPost("/Delivery/insertPicking", {
          "ddh": item.ddh,
          "wph": item.wph,
          "shipmentno": item.shipmentno,
          "randomcheckflag": item.randomcheckflag,
          "tsdrollno": tsdrollno,
          "clothcode": item.clothcode,
          "ddqf":item.ddqf
        },
        function(result) {
          if (result.status) {
            mui.confirm("是否继续指定明细", '提示', ['否', '是'], function(e) {
              if (e.index == 1) {
                // 继续该页面进行扫码
                v.scanQRCode(item);
              }else{
                v.$router.push({ "name": "deliveryDetail", params: jsonPara({ "shipmentno": item.shipmentno }) });
              }
            });
          } else {
            mui.toast(result.message);
            mui.confirm(result.message + "<br/>是否重新扫码?", '提示', ['否', '是'], function(e) {
              if (e.index == 1) {
                // 继续该页面进行扫码
                v.scanQRCode(item);
              }
            });
          }
        }
      );
    },
     // 确认提示框
    confirm_msg(msg,callback){
      var v = this;
      mui.confirm(msg, '提示', ['否', '是'], function(e) {
        if (e.index == 1) {
          if(callback)callback();
        }
      });
    },
    scanQRCodeComfirm(item, e){
      var v = this;
      var li =$(e.target).parents('li');
      if(li.length<=0)return;
      li = li[0];

      v.scan_count = 0;

      setTimeout(function() {
        mui.swipeoutClose(li);
      }, 0);
      
      v.scanBZ(item);
    },
    scanBZ(item){
        var v = this;
        wx.scanQRCode({
        desc: 'scanQRCode desc',
        needResult: 1, // 默认为0，扫描结果由企业微信处理，1则直接返回扫描结果，
        scanType: ["qrCode", "barCode"], // 可以指定扫二维码还是一维码，默认二者都有
        success: function(res) {
          // 回调
          var result = res.resultStr; // 当needResult 为 1 时，扫码返回的结果
          //alert(result);
          if (!result > 1) {
            mui.toast('无效二维码')
          } else {
            // 扫TSD标签二维码，解析获取二维码的坯布信息，校验二维码在出库指示单中是否存在，若存在，则更新扫码状态的值
            // TSD卷号截取，获取前8位 2020/06/28
            var rollstr = result.substr(0,8);
            v.updBZScan(item, rollstr);
          }
        },
        error: function(res) {
          if (res.errMsg.indexOf('function_not_exist') > 0) {
            mui.toast('版本过低请升级')
          }
        }
      });
    },
    updBZScan(item, tsdrollno) { // 校验坯布卷是否存在当前指示单中并更新扫描结果
      //alert(tsdrollno);
      var v = this;
      v.nyy.doPost("/Delivery/updateBZScan", {
          "ddh": item.ddh,
          "wph": item.wph,
          "shipmentno": item.shipmentno,
          "tsdrollno": tsdrollno
        },
        function(result) {
          if (result.status) {
            v.scan_count = v.scan_count + 1;
            let tjfxflg = result.data.tjfxflg || false;
            if(tjfxflg){
               mui.alert("本次共计扫描" + v.scan_count + "卷.<br/>该指示出库完成，已自动提交发货。","消息提示",function(){
                  v.getDeliveryLst();
              });
            }else{
              mui.confirm("是否继续扫码装车", '提示', ['否', '是'], function(e) {
                if (e.index == 1) {
                  v.getDeliveryLst();
                  // 继续该页面进行扫码
                  v.scanBZ(item);
                }else{
                  //v.$router.push({ "name": "deliveryDetail", params: jsonPara({ "shipmentno": item.shipmentno }) });
                  // 获取共计扫码卷，弹出提示画面。刷新列表
                  mui.alert("本次共计扫描" + v.scan_count + "卷.","消息提示",function(){
                      v.getDeliveryLst();
                  });
                }
              });
            }
          } else {
            mui.toast(result.message);
            mui.confirm(result.message, '提示', ['否', '是'], function(e) {
              if (e.index == 1) {
                v.getDeliveryLst();
                // 继续该页面进行扫码
                v.scanBZ(item);
              }else{
                // 获取共计扫码卷，弹出提示画面。刷新列表
                mui.alert("本次共计扫描" + v.scan_count + "卷.","消息提示",function(){
                    v.getDeliveryLst();
                });
              }
            });
          }
        }
      );
    }
  }
}
</script>
<style scoped>
@import "../../static/css/sampling.css";
@import "../../static/css/samplinghistory.css";
@import "../../static/css/filterorder.css";
</style>



// WEBPACK FOOTER //
// src/components/delivery.vue